import {animateByClass} from "../../../Library/Animation.js";

document.addEventListener('click', async (event) => {
    const target = event.target.closest('.remove-action');

    if (!target) {
        return;
    }

    const action = target.closest('.automation-action');
    const index  = Array.from(action.parentNode.querySelectorAll('.automation-action')).indexOf(action);

    await animateByClass(action, 'remove-action-animation');

    action.remove();

    document.querySelector('.side-panel')?.dispatchEvent(new CustomEvent('automationactionremoved', {
        detail: { index },
    }));
});
